import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ComponentModel } from 'src/app/models/maintenance/component.model';
import { MaintenanceRoutineModel } from 'src/app/models/maintenance/maintenance-routine.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ComponentService } from 'src/app/services/maintenance/component.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterComponentComponent } from '../register-component/register-component.component';

@Component({
  selector: 'app-component',
  templateUrl: './component.component.html',
  styleUrls: ['./component.component.scss'],
  standalone: false
})
export class ComponentComponent implements OnInit {
  private readonly componentService = inject(ComponentService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly toastHandlerService = inject(ToastHandlerService);

  @ViewChild('componentModal') componentModalComponent?: CustomModalComponent | null = null;
  @Input('maintenanceRoutineModel') set changeDate(change: MaintenanceRoutineModel) {
    this.changeMaintenanceRoutine(change);
  }
  @Input() permissionUpdatable: boolean = false;
  @Output() emitSelectedComponent = new EventEmitter<ComponentModel>();
  @Output() quantityComponents = new EventEmitter<number>();

  components: ComponentModel[] = [];
  componentRegisterModal = RegisterComponentComponent;
  inputsForRegister$ = new BehaviorSubject<any>({
    componentModel: new ComponentModel(),
    maintenanceRoutineId: 0,
  });
  maintenanceRoutineModel: MaintenanceRoutineModel = new MaintenanceRoutineModel();
  output$ = new Subject<any>();
  selectedComponent: ComponentModel = new ComponentModel();
  subscription: Subscription;

  ngOnInit() {
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onReload':
          this.reloadList(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  changeMaintenanceRoutine(change: MaintenanceRoutineModel) {
    this.maintenanceRoutineModel = change;
    if (this.maintenanceRoutineModel.maintenanceRoutineId != 0) {
      this.getComponentsByRoutine();
    } else {
      this.components = [];
      this.selectedComponent = new ComponentModel();
    }
  }

  componentSelected(selectedComponent: ComponentModel) {
    this.selectedComponent = selectedComponent;
    this.emitSelectedComponent.emit(selectedComponent);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar componentes.
          Comuníquese con el administrador del sistema.`);
      return;
    } else if (!this.selectedComponent || this.selectedComponent.componentId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una seleccionar un componente.');
      return;
    } else if (this.maintenanceRoutineModel.active) {
      this.toastHandlerService.showToast('error', 'No es posible eliminar, la rutina de mantenimiento se encuentra cerrada.', 'Atención');
      return;
    }

    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el componente?');
    if (accepted) {
      try {
        await firstValueFrom(this.componentService.deleteComponent(this.selectedComponent.componentId));
        this.selectedComponent = new ComponentModel();
        await this.getComponentsByRoutine();
        this.toastHandlerService.showToast('success', 'El componente fue eliminado exitosamente.');
      } catch (error) {
        console.error('Error al eliminar el componente.', error);
      }
    }
  }

  async getComponentsByRoutine() {
    try {
      const response = await firstValueFrom(this.componentService.getComponentsByRoutineAsync(this.maintenanceRoutineModel.maintenanceRoutineId));
      this.components = response;
      this.quantityComponents.emit(response.length);

    } catch (error) {
      console.error('Error al obtener los componentes por id.', error);
    }
  }

  newComponent() {
    if (this.maintenanceRoutineModel.maintenanceRoutineId == 0) {
      this.toastHandlerService.showToast('warning', `Debe crear el rutina de mantenimiento.`, 'Atención.');
      return;
    } else if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para crear componentes.
          Comuníquese con el administrador del sistema.`);
      return;
    }

    this.inputsForRegister$.next({
      componentModel: this.selectedComponent,
      maintenanceRoutineId: this.maintenanceRoutineModel.maintenanceRoutineId
    });
    this.componentModalComponent?.show();
  }

  async reloadList(reload: boolean) {
    if (reload) {
      await this.getComponentsByRoutine();
    }
  }
}
